import React, { useContext, useEffect, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import AppContext from 'app/contexts/AppContext'
import useAuth from 'app/hooks/useAuth'
import { MatxLoading } from 'app/components'
import { ORDER_PERMISSIONS, hasOrderPermission } from 'app/constants/orderPermissions'
import { hasWarehousePermission } from 'app/constants/warehousePermissions'

const findMatchedRoute = (pathname, routes) => routes.find((r) => r.path === pathname)
    || routes.find((r) => r.matchPrefix && pathname.startsWith(r.matchPrefix))

const getUserRoleAuthStatus = (pathname, user, routes) => {
    if (user === null) return false
    const matched = findMatchedRoute(pathname, routes)

  const authenticated =
    matched && matched.auth && matched.auth.length
      ? matched.auth.includes(user.role)
            : true

    console.log('RoleAuth:', matched, user)
    return authenticated
}

const getTypeUserStatus = (pathname, user, routes) => {
    if (user === null) return false
    const matched = findMatchedRoute(pathname, routes)

  const authenticated =
    matched && matched.typeShow && matched.typeShow.length
      ? matched.typeShow.includes(user.typeAccount)
            : true

    console.log('TypeUser:', matched, user)
    return authenticated
}

const getUserAccessPageRights = (pathname, user, routes) => {
    if (user === null) return false
    const matched = findMatchedRoute(pathname, routes)

    console.log('AccessCheck:', pathname, user, routes, matched)

    const role = String(user?.role || '').toUpperCase()
    const userId = Number(user?.id || 0)
    const hasParentId = user?.id_parent !== undefined || user?.idParent !== undefined
    const parentId = Number(user?.id_parent ?? user?.idParent ?? 0)
    if (role === 'SA' || (userId > 0 && hasParentId && parentId === 0)) return true

  const authenticated = matched?.accessPageName === ORDER_PERMISSIONS.EDIT
      ? hasOrderPermission(user, ORDER_PERMISSIONS.EDIT)
      : String(matched?.accessPageName || '').startsWith('WAREHOUSE_')
          ? hasWarehousePermission(user, matched.accessPageName)
      : matched && matched.accessPageName && matched.accessPageName.length
          ? Array.isArray(user.accessPage) && user.accessPage.includes(matched.accessPageName)
          : true

    console.log('AccessResult:', matched, user)
    return authenticated
}

const mapPathToModuleCode = (pathname = '') => {
    const path = String(pathname || '').toLowerCase()
    if (path.startsWith('/catalog')) return 'catalog'
    if (path.startsWith('/marketing')) return 'marketing'
    if (path.startsWith('/settings/bonussystem')) return 'bonus'
    if (path.startsWith('/warehouse')) return 'warehouse'
    if (path.startsWith('/settings/telephony')) return 'telephony'
    if (path.startsWith('/settings/frontpadsync') || path.startsWith('/settings/sitecatalogsync')) return 'ext_api'
    return ''
}

const getBillingFeatureStatus = (pathname, user) => {
    if (user === null) return false
    const moduleCode = mapPathToModuleCode(pathname)
    if (!moduleCode) return true
    const map = {
        catalog: 'feature_catalog',
        marketing: 'feature_marketing',
        bonus: 'feature_bonus',
        warehouse: 'feature_warehouse',
        telephony: 'feature_telephony',
        ext_api: 'feature_ext_api',
    }
    const featureKey = map[moduleCode] || ''
    if (!featureKey) return true
    const features = user?.billingFeatures
    if (!features || typeof features !== 'object') return true
    if (!Object.prototype.hasOwnProperty.call(features, featureKey)) return true
    return !!features[featureKey]
}

const AuthGuard = ({ children }) => {
    const {
        isAuthenticated,
        isInitialised,
        user
    } = useAuth()

    const [previouseRoute, setPreviousRoute] = useState(null)
    const { pathname } = useLocation()
    const { routes } = useContext(AppContext)

    useEffect(() => {
        if (previouseRoute !== null) setPreviousRoute(pathname)
    }, [pathname, previouseRoute])

    // ⏳ Ожидаем инициализацию авторизации
    if (!isInitialised) return <MatxLoading />

    const isUserRoleAuthenticated = getUserRoleAuthStatus(pathname, user, routes);
    const isUserTypeAccountPage = getTypeUserStatus(pathname, user, routes);
    const isUserAccessPageRights = getUserAccessPageRights(pathname, user, routes);
    const isBillingFeatureAllowed = getBillingFeatureStatus(pathname, user);

    console.log('Доступ к странице - ',isUserRoleAuthenticated, isUserTypeAccountPage);

    // IF YOU NEED ROLE BASED AUTHENTICATION,
    // UNCOMMENT ABOVE TWO LINES, getUserRoleAuthStatus METHOD AND user VARIABLE
    // AND COMMENT OUT BELOW LINE
    let authenticated = isAuthenticated

    if (authenticated){
        if (isUserRoleAuthenticated && isUserTypeAccountPage && isUserAccessPageRights && isBillingFeatureAllowed) {
            return <>{children}</>
        }else{
            return (
                <Redirect
                    to={{
                        pathname: '/session/notAuthRole',
                        state: { redirectUrl: previouseRoute },
                    }}
                />
            )
        }
    } else {
        return (
            <Redirect
                to={{
                    pathname: '/session/signin',
                    state: { redirectUrl: previouseRoute },
                }}
            />
        )
    }
}

export default AuthGuard
